import axios from "axios";

const fetchHistory = () => axios.get(`/api/v1/sql_editor_histories`);

const sqlEditorHistoryApi = {
  fetchHistory,
};

export default sqlEditorHistoryApi;
